import React from "react";
import {closePopup, getValue, inputMaxLength} from "../../../static/js/Common2";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import {DataPicker1} from "../../picker/DataPicker1";
import {newCouponApi, setCouponApi} from "../../../static/js/service/couponService";

const CouponPopupV2 = React.memo((props) => {
  const shopId = props.shopId;

  const addBtnEvent = () => {
    const name = getValue("name1");
    const minOrderCost = getValue("couponMinCost1");
    const discountCost = getValue("couponCost1");
    const availableDays = getValue("couponUseTime1");
    const issuedCount = getValue("couponCount1");
    const startDay = getValue("startDate1");
    const endDay = getValue("endDate1");
    const state = getValue("state1");
    const deliveryList = document.querySelector('input[name="deliType"]:checked').value;

    // 유효성 검증
    if(name === "") {
      alert("쿠폰명을 입력해주세요.");
      return false;
    }
    if(minOrderCost === "") {
      alert("최소 주문금액을 입력해주세요.");
      return false;
    }
    if(discountCost === "") {
      alert("할인금액을 입력해주세요.");
      return false;
    }
    if(availableDays === "") {
      alert("사용기간을 입력해주세요.");
      return false;
    }
    if(Number(availableDays) > 255) {
      alert("사용기간은 최대 255일까지 가능합니다.");
      return false;
    }
    if(issuedCount === "") {
      alert("발급수량을 입력해주세요.");
      return false;
    }
    if(startDay === "") {
      alert("발급 시작일을 입력해주세요.");
      return false;
    }
    if(endDay === "") {
      alert("발급 종료일을 입력해주세요.");
      return false;
    }
    if(deliveryList === undefined) {
      alert("배달 유형을 선택해주세요.");
      return false;
    }

    let deliType = [Number(deliveryList)];
    if (Number(deliveryList) === 0) deliType = [1,2];

    // 데이터 생성
    let data= {
      name: name,
      desc: name,
      target: 1,
      useRandomCode: false,
      type: 1,
      channelType: 2,
      couponStatus: Number(state),
      deliveryTypeList: deliType,
      paymentTypeList: [1,2,6,9],
      minOrderCost: Number(minOrderCost),
      discountCost: Number(discountCost),
      couponUseType: 2,
      availableDays: Number(availableDays),
      issuedStartDateTime: startDay + " 00:00:00",
      issuedEndDateTime: endDay + " 23:59:59",
      useStartDateTime: startDay + " 00:00:00",
      useEndDateTime: endDay + " 23:59:59",
      issuedCount: 0,
      remainCount: Number(issuedCount),
      reissueEnableCount: Number(issuedCount),
      reissueEnabled: true,
      shopOverlapUseEnabled: false,
      eventOverlapUseEnabled: false,
      shopIdList: [Number(shopId)]
    }

    newCouponApi(data).then(() => {
      window.location.href = `/v2/coupon?shopSelect=${shopId}`;
    }).catch(() => {
      alert("동일한 쿠폰명을 사용할 수 없습니다.");
    });
  }

  const setBtnEvent = () => {
    const couponId = getValue("couponId2");
    const name = getValue("name2");
    const minOrderCost = getValue("couponMinCost2");
    const discountCost = getValue("couponCost2");
    const availableDays = getValue("couponUseTime2");
    const startDay = getValue("startDate2");
    const endDay = getValue("endDate2");
    const state = getValue("state2");
    const deliveryList = document.querySelector('input[name="deliType2"]:checked').value;

    // 유효성 검증
    if(name === "") {
      alert("쿠폰명을 입력해주세요.");
      return false;
    }
    if(minOrderCost === "") {
      alert("최소 주문금액을 입력해주세요.");
      return false;
    }
    if(discountCost === "") {
      alert("할인금액을 입력해주세요.");
      return false;
    }
    if(availableDays === "") {
      alert("사용기간을 입력해주세요.");
      return false;
    }
    if(Number(availableDays) > 255) {
      alert("사용기간은 최대 255일까지 가능합니다.");
      return false;
    }
    if(startDay === "") {
      alert("발급 시작일을 입력해주세요.");
      return false;
    }
    if(endDay === "") {
      alert("발급 종료일을 입력해주세요.");
      return false;
    }
    if(deliveryList === undefined) {
      alert("배달 유형을 선택해주세요.");
      return false;
    }

    let deliType = [Number(deliveryList)];
    if (Number(deliveryList) === 0) deliType = [1,2];

    let data = {
      couponStatus: Number(state),
      deliveryTypeList: deliType,
      minOrderCost: Number(minOrderCost),
      discountCost: Number(discountCost),
      useStartDateTime: startDay + " 00:00:00",
      useEndDateTime: endDay + " 23:59:59",
      availableDays: Number(availableDays),
      issuedStartDateTime: startDay + " 00:00:00",
      issuedEndDateTime: endDay + " 23:59:59"
    }

    setCouponApi(couponId, data).then(() => {
      alert("쿠폰정보가 수정되었습니다.");
      window.location.reload();
    }).catch((e) => {
      console.log(e)
    });
  }

  return (
    <>
      <div id="newCouponPopup" className="newCouponPopup popupV2 hide">
        <div className="popupContainer width700">
          <div className="popupTitle">
            <h2>쿠폰 등록</h2>
            <button className="closeBtn stopCloseBtn" onClick={() => closePopup("newCouponPopup")}>
              <img src={ closeV2 } alt="취소" />
            </button>
          </div>
          <div className="popupContent">
            <div className="popupFlexBox popupFlexBox1">
              <div className="flexTitle">쿠폰명</div>
              <div className="flexContent">
                <input
                  id="name1" type="text" maxLength={30}
                  onInput={(e) => inputMaxLength(e)}
                />
              </div>
            </div>
            <div className="popupFlexBox popupFlexBox1">
              <div className="flexTitle">쿠폰 유형</div>
              <div className="radioBox">
                <input type="radio" id="deliType0" className="deliType0" value={0} name="deliType" defaultChecked />
                <label htmlFor="deliType0" className="deliType0 marginRight10">전체</label>
                <input type="radio" id="deliType1" className="deliType1" value={1} name="deliType" />
                <label htmlFor="deliType1" className="deliType1 marginRight10">배달</label>
                <input type="radio" id="deliType2" className="deliType2" value={2} name="deliType" />
                <label htmlFor="deliType2" className="deliType2 marginRight10">포장</label>
                <input type="radio" id="deliType4" className="deliType4 hide" value={4} name="deliType" />
                <label htmlFor="deliType4" className="deliType4 marginRight10 hide">택배배송</label>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>상태</div>
              <div className='flexContent'>
                <select id="state1" className='width150'>
                  <option value={1}>진행</option>
                  <option value={2}>일시정지</option>
                </select>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>할인금액</div>
              <div className='flexContent'>
                <input
                  id='couponCost1' className='width150' type='number' maxLength={8}
                  onInput={(e) => inputMaxLength(e)}
                />원
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>최소주문금액</div>
              <div className='flexContent'>
                <input
                  id='couponMinCost1' className='width150' type='number' maxLength={8}
                  onInput={(e) => inputMaxLength(e)}
                />원
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>쿠폰 수량</div>
              <div className='flexContent'>
                <input
                  id='couponCount1' className='width120' type='number' maxLength={8}
                  onInput={(e) => inputMaxLength(e)}
                />개
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>발급 시작일</div>
              <div className='flexContent d-flex a-center j-left'>
                <div className='selectBox'>
                  <DataPicker1 id='startDate1' day={ new Date() } />
                </div>
                <span> 부터</span>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>발급 종료일</div>
              <div className='flexContent d-flex a-center j-left'>
                <div className='selectBox'>
                  <DataPicker1 id='endDate1' day={ new Date() } />
                </div>
                <span> 까지</span>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>사용기간</div>
              <div className='flexContent'>
                <input
                  id='couponUseTime1' className='width120 dayCheck' type='number' maxLength={3}
                  onInput={(e) => inputMaxLength(e)}
                />일
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'></div>
              <div className='flexContent'>
                <p className="fs-14">※ 고객이 쿠폰 발급일로부터 사용할 수 있는 유효일수 입니다.</p>
              </div>
            </div>

          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn' onClick={() => closePopup("newCouponPopup")}>취소</button>
            <button type='button' className='newCouponPopupBtn blueBtn' onClick={addBtnEvent}>확인</button>
          </div>
        </div>
      </div>
      <div id="modiCouponPopup" className="newCouponPopup popupV2 hide">
        <div className="popupContainer width700">
          <div className='popupTitle'>
            <h2>쿠폰 수정</h2>
            <button className='closeBtn stopCloseBtn' onClick={() => closePopup("modiCouponPopup")}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className="popupContent">
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>쿠폰명</div>
              <div className='flexContent'>
                <input
                  id='name2' type='text' maxLength={30} readOnly
                  onInput={(e) => inputMaxLength(e)}
                />
                <input
                  id='couponId2' type='hidden' maxLength={30}
                  onInput={(e) => inputMaxLength(e)}
                />
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>쿠폰 유형</div>
              <div className='radioBox'>
                <input type="radio" id="deliType20" className="deliType0" value={0} name="deliType2" />
                <label htmlFor="deliType20" className="deliType20 marginRight10">전체</label>
                <input type='radio' id='deliType21' className='deliType1' value={1} name='deliType2' />
                <label htmlFor='deliType21' className='deliType1 marginRight10'>배달</label>
                <input type='radio' id='deliType22' className='deliType2' value={2} name='deliType2' />
                <label htmlFor='deliType22' className='deliType2 marginRight10'>포장</label>
                <input type='radio' id='deliType24' className='deliType4 hide' value={4} name='deliType2' />
                <label htmlFor='deliType24' className='deliType4 hide'>택배배송</label>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>상태</div>
              <div className='flexContent'>
                <select id="state2" className='width150'>
                  <option value={1}>진행</option>
                  <option value={2}>일시정지</option>
                  <option value={3}>종료</option>
                </select>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>할인금액</div>
              <div className='flexContent'>
                <input
                  id='couponCost2' className='width150' type='number' maxLength={8}
                  onInput={(e) => inputMaxLength(e)}
                />원
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>최소주문금액</div>
              <div className='flexContent'>
                <input
                  id='couponMinCost2' className='width150' type='number' maxLength={8}
                  onInput={(e) => inputMaxLength(e)}
                />원
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>발급 수량</div>
              <div className='flexContent'>
                <input
                  id='issuedCount2' className='width120' type='number' maxLength={8} readOnly
                  onInput={(e) => inputMaxLength(e)}
                />개
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>남은 수량</div>
              <div className='flexContent'>
                <input
                  id='couponCount2' className='width120' type='number' maxLength={8} readOnly
                  onInput={(e) => inputMaxLength(e)}
                />개
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>발급 시작일</div>
              <div className='flexContent d-flex a-center j-left'>
                <div className='selectBox'>
                  <DataPicker1 id='startDate2' day={ new Date() } />
                </div>
                <span> 부터</span>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>발급 종료일</div>
              <div className='flexContent d-flex a-center j-left'>
                <div className='selectBox'>
                  <DataPicker1 id='endDate2' day={ new Date() } />
                </div>
                <span> 까지</span>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>사용기간</div>
              <div className='flexContent'>
                <input
                  id='couponUseTime2' className='width120 dayCheck' type='number' maxLength={3}
                  onInput={(e) => inputMaxLength(e)}
                />일
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'></div>
              <div className='flexContent'>
                <p className="fs-14">※ 고객이 쿠폰 발급일로부터 사용할 수 있는 유효일수 입니다.</p>
              </div>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn' onClick={() => closePopup("modiCouponPopup")}>취소</button>
            <button type='button' className='modiCouponPopupBtn blueBtn' onClick={setBtnEvent}>수정</button>
          </div>
        </div>
      </div>
    </>
  )
})

export default CouponPopupV2;